import React from "react";
import { useParams, Link } from "react-router-dom";
import ProgressCircle from "../components/ProgressCircle";
import ChevronRight from "../assets/icons/chevron-right.svg";
import Ellipsis from "../assets/icons/ellipsis.svg";
import { useGlobalState } from "../context/Global";
import Suitcase from "../assets/icons/suitcase.svg";

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

function Phases({ type }) {
  const { phases } = useGlobalState();

  return phases?.map((p, i) => <Phase key={"phase" + p.id} type={type} {...p} />);
}

function Phase({ type, id, title, description }) {
  const params = useParams();
  const { tasksBundled, tasksTotal, tasksChecked, firstUncheckedTaskForPhaseID } = useGlobalState();
  const [isOpen, setIsOpen] = React.useState(Number(params.phase) === id);
  const tasksProgress = (tasksChecked(id) / tasksTotal(id)) * 100;

  return type === "large" ? (
    <Link to={`/checklist/${id}/${firstUncheckedTaskForPhaseID(id)?.$?.id}`} className="flex relative bg-gray-100 hover:bg-primary-light px-8 py-8 mb-4">
      <div className="flex-grow-0 flex-shrink-0 text-black text-right font-bold mr-2">{id + 1}.</div>
      <div className="flex-grow pr-4">
        <b className="text-black uppercase">{title}</b>
        <div className="my-3">{description}</div>
        <span className="text-primary-dark font-bold block flex items-center">
          Open tasks <ChevronRight width="10px" height="10px" className="mx-1 fill-current" />
        </span>
      </div>
      <div className="flex-grow-0 flex-shrink-0 flex items-center justify-center">
        <ProgressCircle progress={tasksProgress} size={50} label={`${tasksChecked(id)}/${tasksTotal(id)}`} showExtraLabel={true} strokeWidth={5} circleOneStroke="#D6EDEA" circleTwoStroke="#88d0c8" />
      </div>
    </Link>
  ) : (
    <>
      <div
        className="bg-gray-100 border-b border-gray-300 text-black cursor-pointer"
        onClick={
          () => setIsOpen((prevState) => !prevState)
          //setOpenedPhaseId((prevState) => (prevState === id ? null : id))
        }
      >
        <div className="py-3 px-6 flex justify-between items-center ">
          <div>
            <div className="font-bold text-lg uppercase">
              {id + 1}. {title}
            </div>
            {description == false && <div className="text-gray-400">{description}</div>}
          </div>
          <div className="flex-shrink-0">
            <ProgressCircle progress={tasksProgress} size={40} label={`${tasksChecked(id)}/${tasksTotal(id)}`} strokeWidth={4} circleOneStroke="#D6EDEA" circleTwoStroke="#88d0c8" />
          </div>
        </div>
      </div>

      {isOpen &&
        tasksBundled(id).map((b, k) => {
          return b.type === "active" || b.type === "noRole" ? b.tasks.map((t, i) => <Task key={"task" + i} phaseId={id} task={t} />) : <SummaryTasksForOtherRoles key={"task" + k} tasks={b.tasks} />;
        })}
    </>
  );
}

const SummaryTasksForOtherRoles = ({ tasks }) => {
  const { setTasksOpenOtherRoles } = useGlobalState();
  return (
    <div className="py-3 px-4 flex items-center relative border-b border-gray-300 text-primary-dark cursor-pointer" onClick={() => setTasksOpenOtherRoles(tasks.map((t) => t.$.id))}>
      <div className={`absolute w-0.5 h-full z-0 bg-black`} style={{ left: "40px" }} />
      <div className="w-16 text-sm">
        <Ellipsis className="w-3" />
      </div>
      <div>{tasks?.length} task(s) for other roles</div>
    </div>
  );
};

function Task({ phaseId, task }) {
  const { setTasksOpenOtherRoles, tasksOpenOtherRoles } = useGlobalState();
  const { toggleTask, roles, showAllTasks } = useGlobalState();
  const params = useParams();

  const isActive = task?.isActiveForCurrentRoles || (showAllTasks && task?.$.role?.trim() !== "") || task?.$.role?.trim() == "";

  return (
    <div
      className={`${isActive ? (params.phase == phaseId && params.task == task.$.id ? "bg-secondary-light" : "bg-primary-bright") : params.phase == phaseId && params.task == task.$.id ? "bg-secondary-light" : "bg-white"} 
       hover:bg-secondary-light border-b `}
    >
      <div className="flex items-center relative border-b border-gray-400">
        <div className={`absolute  h-full z-0 bg-black`} style={{ left: "40px", width: "1px" }} />
        <div className="w-16 flex-shrink-0 flex items-center pl-3">
          {isActive ? (
            <div className="checkbox ml-5">
              <input type="checkbox" style={isIE11 ? { zIndex: 10 } : {}} defaultChecked={task.checked} onClick={() => toggleTask(phaseId, task.$.id)} />
              <span></span>
            </div>
          ) : (
            <div className="w-16 text-sm">{tasksOpenOtherRoles?.indexOf(task.$.id) === 0 && <Ellipsis className="w-3 cursor-pointer" onClick={() => setTasksOpenOtherRoles([])} />}</div>
          )}
        </div>
        <Link to={`/checklist/${phaseId}/${task.$.id}`} className="text-lg transform-uppercase py-4 px-4 w-full">
          <div className={`flex leading-tight ${isActive ? "text-black " : "text-gray-400"} ${params.task == task.$.id ? "font-bold" : ""}`}>{task.title}</div>

          {roles
            .filter((r) => task.$.role?.split(" ")?.includes(r.$.id))
            .map((r) => (
              <div key={r.$.id} className="text-sm flex items-center ">
                <Suitcase className="fill-current mr-2" width="12" height="15" />
                {r._}
              </div>
            ))}
        </Link>
      </div>
    </div>
  );
}

export default Phases;
